export const roundedNumber = (number) => {
  return Math.floor(number * 100000000) / 100000000;
};
